export default ((arr, item) => arr.includes(item) ? arr.filter(x => x !== item) : [...arr, item]);